import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { zoneInterceptor } from './core/interceptors/zone.interceptor';
import { provideAuth } from './core/providers/auth.provider';
import { provideI18n } from './core/providers/i18n.provider';
import { provideLanguage } from './core/providers/language.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, zoneInterceptor])),
    provideAuth(),
    provideI18n(),
    provideLanguage(),
    provideToastr(),
  ],
};
